var Actions;
(function (Actions) {
    // post data
    Actions["POST_DATA"] = "postMasterSchemaData";
    Actions["UPDATE_DATA"] = "updateMasterSchemaData";
    Actions["GET_ANSWER_TYPE_OPTIONS"] = "getAllAnswerTypeOptionsList";
    Actions["GET_MASTER_SCHEMA_LIST_DETAIL"] = "getMasterSchemaListDetail";
})(Actions || (Actions = {}));
var Mutations;
(function (Mutations) {
    Mutations["SET_ANSWER_TYPE_OPTIONS"] = "setMasterSchemaAnswerTypeOptionsList";
    Mutations["SET_MANDATORY_IN_FORM_OPTIONS"] = "setMasterSchemaPostMandatoryInFormOptions";
    Mutations["SET_MASTER_SCHEMA_LIST_DETAIL"] = "setMasterSchemaListDetail";
    // set data from row
    Mutations["SET_MASTER_QUESTION_CODE_DATA_FROM_RECORD_GRID"] = "setMasterSchemaDataFromRecordGrid";
    // set loading
    Mutations["SET_LOADING"] = "setMasterSchemaPostLoading";
    // clear form input
    Mutations["CLEAR_FORM_INPUT"] = "clearMasterSchemaFormInput";
})(Mutations || (Mutations = {}));
export { Actions, Mutations };
